import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 text-lg font-semibold mb-4">
              <span className="text-primary-500 font-bold">Kakobuy</span>
              <span className="text-foreground-950">Spreadsheet</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Największa polska baza produktów Kakobuy. Gotowe linki, kategorie produktów, QC zdjęcia oraz kompletny przewodnik zakupowy.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="Kakobuy"
              >
                <i className="ri-global-line" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">Nawigacja</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Strona główna
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Kakobuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-finds" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Kakobuy Finds
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">Kategorie</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">Kup teraz</h4>
            <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
              Odwiedź nasz główny sklep i znajdź najlepsze produkty z Chin.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Buy it now
              <i className="ri-arrow-right-line text-xs" />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-xs text-foreground-500">
            Nieoficjalny przewodnik dla użytkowników Kakobuy
          </p>
        </div>
      </div>
    </footer>
  );
}